import type { IImageField } from '@/typescript/interfaces/IImageField';
import type { ITextField } from '@/typescript/interfaces/ITextField';

export function sortFields(fields: IImageField[] | ITextField[]): (IImageField | ITextField)[] {
    // TODO: for saving purpose maybe usefull for later
    // const imgFields: IImageField[] = [];
    // const textFields: ITextField[] = [];
    // Unefective for now - not necessary - may be usefull if we want to sort element on on beloy layer and top layer
    // fields.forEach((field) => {
    //     if ((field as ITextField)?.text || (field as ITextField)?.defaultText) {
    //         textFields.push(field as ITextField);
    //     } else {
    //         imgFields.push(field as IImageField);
    //     }
    // });
    // // return [...imgFields, ...textFields];
    return [...(fields as (IImageField | ITextField)[])];
}
